import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { Editor } from '@tinymce/tinymce-react'
import {
  useGetApprovalPolicyAssignmentLazyQuery,
  useGetApprovalPolicyLazyQuery,
  useGetStandardLetterQuery,
  useUpdateCompanyLetterTemplateMutation,
  useUpdateLetterTemplateMutation,
} from 'generated/graphql'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import AppContext from 'containers/App/Store/AppContext'
import { useEDocTemplate } from './DocTemplate'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import { ELetterParamsService } from './ELetterParametersService/ELetterParamsService'
import { getProductName } from 'utils/logoConfig'

export const LetterDesignForm = (props: any) => {
  const { mode } = props
  const {
    pageMode,
    StandardLetterID,
    LetterTemplateID,
    CompanyID,
    CompanyLetterTemplateID,
  }: any = useParams()
  const isHomeDefault = localStorage.getItem('isDefault')
  const effectiveCompanyID = CompanyID ?? localStorage.getItem('latestCompany')
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { globalState, dispatch }: any = useContext(AppContext as any)
  let history = useHistory()
  let location: any = useLocation()
  let editData = location.state
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const productName = getProductName()

  const { htmlWrapper } = useEDocTemplate()

  //ELetterParams
  const [eLetterParams, setELetterParams] = useState([])
  const approvalCategoryRef = useRef('')
  const letterCategoryRef = useRef('')
  const letterTypeRef = useRef('')
  const hasTriedPolicyRef = useRef(false)
  const hasTriedAssignmentRef = useRef(false)

  useEffect(() => {
    hasTriedPolicyRef.current = false
    hasTriedAssignmentRef.current = false
    setELetterParams([])
  }, [StandardLetterID, CompanyID, effectiveCompanyID])

  const buildParamsFromApproval = approvalPolicy => {
    if (!letterCategoryRef.current || !letterTypeRef.current) return false

    const approvalLevelCount =
      approvalPolicy?.length > 1
        ? approvalPolicy.length
        : approvalPolicy?.[0]?.ApprovalList?.length ?? 0

    if (approvalLevelCount === 0) return false

    const paramsArray = ELetterParamsService.ELetterParamsByModule(
      letterCategoryRef.current,
      letterTypeRef.current,
      approvalLevelCount // number of level of approval determine the number of param in letter
    )

    setELetterParams(paramsArray)
    return true
  }

  const [
    loadApprovalPolicyAssignment,
    {
      loading: loadingApprovalPolicyAssignment,
      data: { getApprovalPolicyAssignment } = {
        getApprovalPolicyAssignment: [],
      },
    },
  ] = useGetApprovalPolicyAssignmentLazyQuery({
    fetchPolicy: 'network-only',
    onError: err => {},
    onCompleted: ({ getApprovalPolicyAssignment }) => {
      const hasParams = buildParamsFromApproval(getApprovalPolicyAssignment)
      if (!hasParams && !hasTriedPolicyRef.current) {
        hasTriedPolicyRef.current = true
        loadApprovalPolicy({
          variables: { Category: approvalCategoryRef.current },
        })
      }
    },
  })

  const {
    loading: StandardLetterLoading,
    data: { getStandardLetter } = {
      getStandardLetter: [],
    },
  } = useGetStandardLetterQuery({
    fetchPolicy: 'network-only',
    variables: { StandardLetterID },
    onCompleted: ({ getStandardLetter }) => {
      let Category
      switch (getStandardLetter[0]?.LetterCategory) {
        case 'ACC_PAYABLE':
          switch (getStandardLetter[0]?.LetterType) {
            case 'PAYMENT':
              Category = 'AP_Payment'
              break
            case 'ADVANCE':
              Category = 'AP_Advance'
              break
          }
          break
        case 'GENERAL_PURCHASE':
          switch (getStandardLetter[0]?.LetterType) {
            case 'PURCHASE_REQUISITION':
              Category = 'GP_PRHeader'
              break
            case 'PURCHASE_ORDER':
              Category = 'GP_POHeader'
              break

            case 'GOOD_RETURN_NOTE':
              Category = 'GP_GRTNHeader'
              break
          }
          break
        default:
          Category = ''
          break
      }

      approvalCategoryRef.current = Category ?? ''
      letterCategoryRef.current = getStandardLetter[0]?.LetterCategory ?? ''
      letterTypeRef.current = getStandardLetter[0]?.LetterType ?? ''
      if (CompanyID) {
        if (!hasTriedAssignmentRef.current) {
          hasTriedAssignmentRef.current = true
          loadApprovalPolicyAssignment({
            variables: { Category: Category, CompanyID: CompanyID },
          })
        }
      } else if (!hasTriedPolicyRef.current) {
        hasTriedPolicyRef.current = true
        loadApprovalPolicy({ variables: { Category: Category } })
      }
    },
  })

  const [
    loadApprovalPolicy,
    {
      loading: loadingApprovalPolicy,
      data: { getApprovalPolicy } = {
        getApprovalPolicy: [],
      },
    },
  ] = useGetApprovalPolicyLazyQuery({
    fetchPolicy: 'network-only',
    onError: err => {},
    onCompleted: ({ getApprovalPolicy }) => {
      buildParamsFromApproval(getApprovalPolicy)
    },
  })

  const [
    updateLetterTemplate,
    { loading: updateLetterTemplateLoading },
  ] = useUpdateLetterTemplateMutation({
    onError: error => {
      setSnackBarMsg(error.message)
    },
    onCompleted: ({ updateLetterTemplate }) => {
      if (updateLetterTemplate) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.updateRecord())
        history.push({
          pathname: `/${pageMode}/general-setting/standard-letter/${StandardLetterID}/letter-template`,
        })
      } else {
        setSnackBarMsg('Update Failed!')
      }
    },
  })
  const [
    updateCompanyLetterTemplate,
    { loading: updateCompanyLetterTemplateLoading },
  ] = useUpdateCompanyLetterTemplateMutation({
    onError: error => {
      setSnackBarMsg(error.message)
    },
    onCompleted: ({ updateCompanyLetterTemplate }) => {
      if (updateLetterTemplate) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.updateRecord())
        history.push({
          pathname: `/${pageMode}/${CompanyID}/company-setting/company-standard-letter/${StandardLetterID}/company-letter-template`,
        })
      } else {
        setSnackBarMsg('Update Failed!')
      }
    },
  })

  const [contentValue, setContentValue] = useState('')
  const [ConfirmationDialog, setConfirmationDialog] = useState(false)
  const [IsChange, setIsChange] = useState(false)
  const checkIsChange = (changed: boolean) => {
    if (!changed) {
      return history.goBack()
    } else {
      return setConfirmationDialog(true)
    }
  }

  useEffect(() => {
    if (!!editData) {
      setContentValue(editData?.TemplateBody)
    }
  }, [editData, document])

  const newContentValue = contentValue?.replaceAll('&nbsp;', '')

  const onSubmit = () => {
    if (CompanyID) {
      updateCompanyLetterTemplate({
        variables: {
          input: { CompanyLetterTemplateID, TemplateBody: newContentValue },
        },
      })
    } else {
      updateLetterTemplate({
        variables: {
          input: { LetterTemplateID, TemplateBody: newContentValue },
        },
      })
    }
  }

  // ================ Params Generation ================
  const companyParams = ELetterParamsService.ELetterCompanyParams()

  // ================ End of Params Generation ================

  let headerTitle
  if (pageMode === 'general-ledger') headerTitle = 'General Ledger'
  else if (pageMode === 'cash-book') headerTitle = 'Cash Book'
  else if (pageMode === 'account-receivable') headerTitle = 'Account Receivable'
  else if (pageMode === 'account-payable') headerTitle = 'Account Payable'
  else if (pageMode === 'inventory-control') headerTitle = 'Inventory Control'
  else if (pageMode === 'general-purchase') headerTitle = 'General Purchase'

  // WHY ARE YOU USING USEEFFECT MUHAMMAD KOCHA? - EMIR
  // useEffect(() => {
  //   if (pageMode === 'general-ledger') {
  //     headerTitle = 'General Ledger'
  //   } else if (pageMode === 'cash-book') {
  //     headerTitle = 'Cash Book'
  //   } else if (pageMode === 'account-receivable') {
  //     headerTitle = 'Account Receivable'
  //   } else if (pageMode === 'account-payable') {
  //     headerTitle = 'Account Payable'
  //   } else if (pageMode === 'inventory-control') {
  //     headerTitle = 'Inventory Control'
  //   } else if (pageMode === 'general-purchase') {
  //     headerTitle = 'General Purchase'
  //   }
  // }, [pageMode])

  return (
    <>
      {StandardLetterLoading && <Loading />}
      {loadingApprovalPolicyAssignment && <Loading />}
      {updateLetterTemplateLoading && <Loading />}
      {updateCompanyLetterTemplateLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname: CompanyID
              ? `/${pageMode}/${CompanyID}/company-setting/company-standard-letter/${StandardLetterID}/company-letter-template`
              : `/${pageMode}/general-setting/standard-letter/${StandardLetterID}/letter-template`,
          })
        }}
        smTitle={isHomeDefault === 'true' ? productName : headerTitle}
        title={user?.companyName}
        // title={getCompany[0]?.Name}
        routeSegments={
          globalState?.isPathSysAdmin
            ? [
                { name: 'System Admin' },
                { name: 'System Admin' },
                { name: 'Document Template' },
                { name: 'Letter Template', current: true },
              ]
            : [
                { name: 'System Admin' },
                { name: 'Document Template' },
                { name: 'Letter Template', current: true },
              ]
        }
        rightRouteSegments={[
          {
            name: 'Design',
            current: true,
          },
        ]}
      />

      <DynamicSubHeader
        title={editData?.Name} // title text
      />

      <ContentWrapper search>
        {!StandardLetterLoading && eLetterParams?.length > 0 ? (
          <Editor
            apiKey={'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat'}
            // initialValue={'type here'}
            init={{
              convert_urls: false,
              // plugins: KIV for future use
              //   'preview paste importcss searchreplace autolink autosave  directionality code visualblocks visualchars fullscreen image link  template table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
              plugins: `preview paste importcss autolink autosave directionality visualblocks visualchars fullscreen image table hr insertdatetime advlist lists imagetools help quickbars ${user.superUser ===
                true && 'code'}`,
              imagetools_cors_hosts: ['picsum.photos'],
              // menubar: 'file edit view insert format tools table custom ', KIV for future use
              menubar: 'edit view format table custom',
              toolbar:
                ' customInsertButton | undo redo | bold italic underline strikethrough | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor | fullscreen  preview | insertfile image anchor code | ltr rtl',
              toolbar_sticky: true,
              fontsize_formats:
                '6px 7px 8px 9px 10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 32px 36px',
              image_advtab: true,
              entity_encoding: 'raw',
              forced_root_block: false,
              automatic_uploads: true,
              paste_data_images: true, // ✅ allow paste images
              images_upload_handler: (blobInfo, success, failure) => {
                // convert to base64
                success(
                  `data:${blobInfo.blob().type};base64,${blobInfo.base64()}`
                )
              },

              file_picker_types: 'image',
              menu: {
                custom: {
                  title: 'Parameters',
                  items: 'specialparams companyparams docparams',
                },
              },
              setup: function(editor) {
                editor.ui.registry.addButton('customInsertButton', {
                  text: 'Reset',
                  onAction: function(_) {
                    setContentValue(editData?.TemplateBody)
                    setIsChange(true)
                  },
                })
                // ===============================================
                // Add Nested Items for custom Parameters dropdown
                // ===============================================
                editor.ui.registry.addNestedMenuItem('companyparams', {
                  text: 'Company Parameters',
                  getSubmenuItems: () => {
                    return companyParams.map(params => {
                      return {
                        type: 'menuitem',
                        text: params,
                        onAction: function() {
                          editor.insertContent(`${params}`)
                        },
                      }
                    })
                  },
                })

                editor.ui.registry.addNestedMenuItem('docparams', {
                  text: 'Document Parameters',
                  getSubmenuItems: () => {
                    return eLetterParams.map(params => {
                      return {
                        type: 'menuitem',
                        text: params,
                        onAction: function() {
                          editor.insertContent(`${params}`)
                        },
                      }
                    })
                  },
                })

                editor.ui.registry.addNestedMenuItem('specialparams', {
                  text: 'Special Parameters',
                  getSubmenuItems: () => {
                    const specialparams: any = [
                      {
                        type: 'menuitem',
                        text: '[CompanyLogo]',
                        onAction: function() {
                          editor.insertContent(`
                          <img style="max-height: 100px; max-width: 150px;"
                            src="https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg"
                            crossorigin="anonymous"
                          />`)
                        },
                      },
                    ]

                    return specialparams.map(params => {
                      return {
                        type: params.type,
                        text: params.text,
                        onAction: params.onAction,
                      }
                    })
                  },
                })
              },
              height: 700,
            }}
            value={contentValue}
            onEditorChange={(newValue, editor) => {
              setContentValue(newValue)
              setIsChange(true)
            }}
          />
        ) : null}

        <Footer
          options={[
            {
              name: 'Save',
              onClick: () => onSubmit(),
              color: 'primary',
            },
          ]}
        />
      </ContentWrapper>
    </>
  )
}
